import { a as _objectSpread2 } from "./auth-service-tools630.js";
import { createComponent } from "./auth-service-tools631.js";
import { createHook } from "./auth-service-tools637.js";
import "react";
import { useWarning } from "./auth-service-tools670.js";
import { useCreateElement } from "./auth-service-tools633.js";
import { useComposite } from "./auth-service-tools669.js";
import { a as TAB_LIST_KEYS } from "./auth-service-tools697.js";
var useTabList = createHook({
  name: "TabList",
  compose: useComposite,
  keys: TAB_LIST_KEYS,
  useProps: function useProps(options, htmlProps) {
    return _objectSpread2({
      role: "tablist",
      "aria-orientation": options.orientation
    }, htmlProps);
  }
});
var TabList = createComponent({
  as: "div",
  useHook: useTabList,
  useCreateElement: function useCreateElement$1(type, props, children) {
    process.env.NODE_ENV !== "production" ? useWarning(!props["aria-label"] && !props["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/tab") : void 0;
    return useCreateElement(type, props, children);
  }
});
export { TabList, useTabList };